import { buildDetailRowId } from 'utils/table/detailItems'
import { stagingKeys } from 'utils/documents/DocumentMapper/constants' // TODO: Global?

const { UPDATE, DELETE } = stagingKeys

export const syncAgGridSelection = (
  selection,
  { context, node, rowId, detailField }
) => {
  if (detailField && rowId && context?.editedRows) {
    const detailRowId = buildDetailRowId(rowId, node.data)
    const contextDetail = context.editedRows[detailRowId]
    if ([UPDATE, DELETE].includes(contextDetail)) {
      return
    }
  }

  node.setSelected(selection)
}
